import React from 'react';
import Chip from '@mui/material/Chip';

export interface IChipsProps {
  chips: { key: string; value: any; disabled?: boolean }[];
  selected: number;
  setSelected: (_value: number) => void;
  width?: string;
  variant?: 'filled' | 'outlined';
  children?: React.ReactNode;
}
export const ToggleChips = ({ chips, selected, setSelected, width = '3rem', variant, children }: IChipsProps) =>
  chips?.length ? (
    <div className="flex flex-row rounded-full justify-center h-7 text-xs p-[1px] border-1 border-blue-600 text-center">
      {chips.map(({ key, value, disabled }) =>
        value === selected ? (
          <Chip
            sx={{
              width,
              ...(variant === 'outlined' ? { borderColor: '#6571ff' } : { backgroundColor: '#6571ff', color: 'white' }),
            }}
            label={key}
            size="small"
            key={key}
            variant={variant}
          />
        ) : (
          <span
            key={key}
            onClick={() => !disabled && setSelected(value)}
            className={`${disabled ? 'opacity-50' : 'cursor-pointer'} w-[${width}] content-center`}
          >
            {key}
          </span>
        ),
      )}
      {children}
    </div>
  ) : null;
